import Icon from "@ant-design/icons";

const Svg = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" rx="8" fill="#F4F5F7"/>
    <path d="M9.33374 16H22.6671" stroke="#130F26" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9.33374 11H22.6671" stroke="#9A99A3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9.33374 21H16.0004" stroke="#130F26" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
export const MyIcon = (props: any) => <Icon component={Svg} {...props} />;

